// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b57c3825","963":"ccea8c01"}[chunkId] + ".chunk.js";
};